import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ContactPerson from "./ContactPerson/ContactPerson";
import MuiButton from "../../../../../../Components/Button/Button";
import WorkingHours from "./WorkingHours/WorkingHours";
import Treatments from "./Treatments/Treatments";
import AddButton from "../../../../../../Components/AddButton/AddButton";
import { genericFetchData } from "../../../../../../Services/Service";
import { AddNewTreatment } from "../Finance/Ip/Ip";
import { checkPermission } from "../../../../../../Utils/Permissions";
import { checkNumberLimit } from "../../../../../../Utils/helper";
import { TextView } from "../../../../../../Components/TextView";
function InsuranceView({ hospitalId }) {
  const [insuranceDetails, setInsuranceDetails] = useState({
    contactPersonName: "N/A",
    contactPersonNumber: 0,
    fromWorkHr: 0,
    hospitalId: 0,
    hospitalTreatmentShares: [
      {
        mykareShare: "N/A",
        price: "N/A",
        treatmentId: 0,
      },
    ],
    insuranceIds: [0],
    toWorkHr: 0,
  });

  const [isEditable, setIsEditable] = useState(false);

  const [insurance, setInsurance] = useState([]);
  const getAllInsurance = async () => {
    const response = await genericFetchData(`/insurance/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      const data = responseData?.insurances.map((val) => ({
        id: val.insuranceId,
        name: val.insuranceName,
      }));
      setInsurance(data);
    } else {
      console.log("=======error", responseData);
    }
  };

  const handleDuplicate = () => {
    const newDuplicate = {
      mykareShare: "",
      price: "",
      treatmentId: 0,
    };
    setInsuranceDetails((prevDuplicates) => ({
      ...prevDuplicates,
      hospitalTreatmentShares: [
        ...prevDuplicates.hospitalTreatmentShares,
        newDuplicate,
      ],
    }));
  };

  const saveInternationalDetails = async () => {
    const hospitalTreatments = insuranceDetails.hospitalTreatmentShares.map(
      (val) => {
        return {
          mykareShare: val?.mykareShare,
          price: val?.price,
          treatmentId: val?.treatment ? val?.treatment?.id : val?.treatmentId,
        };
      }
    );
    const postData = {
      contactPersonName: insuranceDetails.contactPersonName,
      contactPersonNumber: insuranceDetails.contactPersonNumber,
      fromWorkHr: insuranceDetails.fromWorkHr,
      centerId: hospitalId,
      hospitalTreatmentShares: hospitalTreatments,
      insuranceIds: insuranceDetails.insuranceIds,
      toWorkHr: insuranceDetails.toWorkHr,
    };
    try {
      const response = await genericFetchData(
        `/center/insurance/save`,
        "POST",
        postData
      );
      const status = response.status;
      const responseData = await response.json();
      if (status == 200) {
        alert("saved success");
      } else {
        console.log("status=================", status);
      }
    } catch (error) {
      console.log("error=================", error);
    }
  };

  const getHospitalInsuranceDetails = async () => {
    const response = await genericFetchData(
      `/center/insurance?centerId=${hospitalId}&context=INSURANCE_TREATMENT_SHARE`,
      "GET"
    );
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      const { treatmentShareResponses, insurances, ...updatedData } =
        responseData;
      const data = insurances.map((val) => ({
        id: val.insuranceId,
        name: val.insuranceName,
      }));

      setInsuranceDetails({
        ...updatedData,
        insurances: data,
        hospitalTreatmentShares: treatmentShareResponses.length
          ? treatmentShareResponses
          : [
              {
                mykareShare: "",
                price: "",
                treatmentId: 0,
              },
            ],
      });
      setIsEditable(false);
    } else {
      console.log("=======error", status);
    }
  };

  useEffect(() => {
    getAllInsurance();
    getHospitalInsuranceDetails();
  }, []);

  return (
    <Box
      width="100%"
      border={"1px solid lightgrey"}
      borderRadius={2}
      paddingX={5}
      paddingY={5}
    >
      <Grid
        container
        lg={12}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid item lg={1}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            Insurance
          </Typography>
        </Grid>
      </Grid>
      <ContactPerson
        isEditable={isEditable}
        setName={(value) =>
          setInsuranceDetails((s) => ({ ...s, contactPersonName: value }))
        }
        name={insuranceDetails.contactPersonName}
        setNumber={(value) => {
          const isNumber = checkNumberLimit(value);
          if (isNumber) {
            setInsuranceDetails((s) => ({ ...s, contactPersonNumber: value }));
          }
        }}
        number={insuranceDetails.contactPersonNumber}
      />
      {/* <WorkingHours
        isEditable={isEditable}
        insurances={insurance}
        insuranceDetails={insuranceDetails}
        setInsuranceDetails={setInsuranceDetails}
      /> */}
      <Grid item container lg={12}>
        <Grid item>
          <Typography lineHeight={2} color="grey" fontWeight={600}>
            Working Hours
          </Typography>
          <TextView>
            {`${insuranceDetails.fromWorkHr}hr To ${insuranceDetails.toWorkHr}hr`}
          </TextView>
        </Grid>
      </Grid>

      {insuranceDetails?.hospitalTreatmentShares?.map((val, i) => {
        return (
          <AddNewTreatment
            isInsurance
            isEditable={isEditable}
            setPrice={(value) => {
              insuranceDetails.hospitalTreatmentShares[i].price = value;
              setInsuranceDetails((s) => ({
                ...s,
                hospitalTreatmentShares:
                  insuranceDetails.hospitalTreatmentShares,
              }));
            }}
            price={val.price}
            setShare={(value) => {
              insuranceDetails.hospitalTreatmentShares[i].mykareShare = value;
              setInsuranceDetails((s) => ({
                ...s,
                hospitalTreatmentShares:
                  insuranceDetails.hospitalTreatmentShares,
              }));
            }}
            share={val.mykareShare}
            setTreatment={(value) => {
              insuranceDetails.hospitalTreatmentShares[i].treatmentId =
                value.id;
              setInsuranceDetails((s) => ({
                ...s,
                hospitalTreatmentShares:
                  insuranceDetails.hospitalTreatmentShares,
              }));
            }}
            treatment={val?.treatment}
            isCancel={i !== 0}
            onClose={() => {
              const updatedVal = [...insuranceDetails.hospitalTreatmentShares];
              updatedVal.splice(i, 1);
              setInsuranceDetails((s) => ({
                ...s,
                hospitalTreatmentShares: updatedVal,
              }));
            }}
          />
        );
      })}
    </Box>
  );
}

export default InsuranceView;
